import PlayerControls from './PlayerControls'
import TimeLineControl from './TimeLineControl'
import VolumeControl from './VolumeControl'
import PlayControl from './PlayControl'

export { TimeLineControl, VolumeControl, PlayControl }

export default PlayerControls
